// extracted by mini-css-extract-plugin
module.exports = {"decoratedText":"_TrAJAV_z","badge":"_JBIg1u3w"};